export default __webpack_public_path__ + "static/media/icone-biometric-invalid.13be7c45.svg";